function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { rehydrate } from "./rehydrate.js";
import { persist } from "./persist.js";
import { REMEMBER_PERSISTED } from "./action-types.js";
import { pick, throttle, debounce } from "./utils.js";
import isDeepEqual from "./is-deep-equal.js";
var init = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (store, rememberedKeys, _ref) {
    var prefix = _ref.prefix,
      driver = _ref.driver,
      serialize = _ref.serialize,
      unserialize = _ref.unserialize,
      persistThrottle = _ref.persistThrottle,
      persistDebounce = _ref.persistDebounce,
      persistWholeStore = _ref.persistWholeStore;
    yield rehydrate(store, rememberedKeys, {
      prefix: prefix,
      driver: driver,
      unserialize: unserialize,
      persistWholeStore: persistWholeStore
    });
    var oldState = {};
    var persistFunc = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* () {
        var state = pick(store.getState(), rememberedKeys);
        yield persist(state, oldState, {
          prefix: prefix,
          driver: driver,
          serialize: serialize,
          persistWholeStore: persistWholeStore
        });
        if (!isDeepEqual(state, oldState)) {
          store.dispatch({
            type: REMEMBER_PERSISTED,
            payload: state
          });
        }
        oldState = state;
      });
      return function persistFunc() {
        return _ref3.apply(this, arguments);
      };
    }();
    if (persistDebounce && persistDebounce > 0) {
      store.subscribe(debounce(persistFunc, persistDebounce));
    } else {
      store.subscribe(throttle(persistFunc, persistThrottle));
    }
  });
  return function init(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export default init;
//# sourceMappingURL=init.js.map